// extracted by mini-css-extract-plugin
export var addButton = "_o3-0";
export var border = "_o3-8";
export var check = "_o3-h";
export var danger = "_o3-6";
export var dropdownContainer = "_o3-1";
export var editModalBody = "_o3-j";
export var footerContainer = "_o3-i";
export var fullWidth = "_o3-a";
export var hide = "_o3-9";
export var icon = "_o3-3";
export var input = "_o3-7";
export var inputFlex = "_o3-b";
export var inputWrapper = "_o3-c";
export var manualFocus = "_o3-5";
export var optionButton = "_o3-4";
export var pillWrapper = "_o3-e";
export var pointer = "_o3-2";
export var showOverflow = "_o3-f";
export var tagsFlex = "_o3-d";
export var xButton = "_o3-g";